// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4Onh_","image":"styles_image__3brp-"};